export default [
    { name: "Paula", email: "paula.moreira@nucont.com" },
    { name: "Michael", email: "michael.pascoa@nucont.com" },
    { name: "Matheus", email: "matheus.queiroga@nucont.com" },
    { name: "Luis", email: "luis@nucont.com" },
    { name: "Fernanda", email: "fernanda@nucont.com" },
    { name: "Nucont Hackers", email: "nuconthackers@gmail.com" },
    {
        name: "Alessandra Souza",
        email: "alessandra.souza@nucont.com"
    },
    {
        name: "João Lucas Couto",
        email: "joaolucas.couto@nucont.com"
    },
    { name: "Hadna Esteves", email: "hadna.esteves@nucont.com" },
    {
        name: "Matheus Queiroga",
        email: "matheus.queiroga@nucont.com"
    },
    // { name: "Vinicius", email: "vinicius@nucont.com" },
    // { name: "Fernando", email: "fernando.pinheiro@nucont.com" },
    {
        name: "Lilian Alcantra",
        email: "lilian.alcantara@nucont.com"
    },
    {
        name: "Mariana Caetano",
        email: "marianna.caetano@nucont.com"
    },
    {
        name: "Financeiro",
        email: "financeiro@nucont.com"
    },
    {
        name: "Nucont",
        email: "nusucesso@nucont.com"
    },
    {
        name: "Joice",
        email: "joice@nucont.com"
    }
];
